import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-userlist-segment',
  templateUrl: './userlist-segment.component.html',
  styleUrls: ['./userlist-segment.component.css']
})
export class UserlistSegmentComponent implements OnInit {
  @Input() viewType: string;
  @Input() availableList: any[];
  @Input() assignedList: any[];
  @Output() selectionChange = new EventEmitter<any>();

  constructor() { }

  ngOnInit() { }

  public toggleSelection(item) {
    item.selected = !item.selected;
  }

  public moveSelected(direction) {
    if (direction === "left") {
      this.assignedList.forEach(item => {
        if (item.selected) {
          this.availableList.push(item);
        }
      });
      this.assignedList = this.assignedList.filter(i => !i.selected);
    } else {
      this.availableList.forEach(item => {
        if (item.selected) {
          this.assignedList.push(item);
        }
      });
      this.availableList = this.availableList.filter(i => !i.selected);
    }
    this.emitChange();
  }

  public moveAll(direction) {
    if (direction === "left") {
      this.availableList = [...this.availableList, ...this.assignedList];
      this.assignedList = [];
    } else {
      this.assignedList = [...this.assignedList, ...this.availableList];
      this.availableList = [];
    }
    this.emitChange();
  }

  private emitChange() {
    this.selectionChange.emit({
      availableList: this.availableList,
      assignedList: this.assignedList,
      listChanges: this.assignedList.length > 0 ? true : false
    });
  }

}

